import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {UserCheckEntitlementsComponent} from './core/user-check-entitlements/user-check-entitlements.component';
import {HomeComponent} from './home/home/home.component';

const appRoutes: Routes = [
  {
    path: 'check-entitlements',
    component: UserCheckEntitlementsComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  }
  // { path: 'home',  loadChildren: './home/home.module#HomeModule'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes  //,
      // {
        // onSameUrlNavigation: 'reload', // not this did not work in example with signout
        // enableTracing: true // <-- debugging purposes only
      // }
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
